import React, { useEffect, useRef } from "react";
import { hasMarketingConsent } from "../consent";

export default function AdBanner({ slot, format = "auto", style = {} }) {
  const pushed = useRef(false);
  const hasConsent = hasMarketingConsent();

  useEffect(() => {
    if (!hasConsent || !slot || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {}
  }, [hasConsent, slot]);

  if (!hasConsent || !slot) return null;

  return (
    <div style={{ textAlign: "center", overflow: "hidden", ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-1892604224494997"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
